import styled, { css } from 'styled-components';

const sizeStyles = {
  small: css`
    font-size: 12px;
    line-height: 16px;
    height: 24px;
    padding: 4px 6px;
  `,
  medium: css`
    font-size: 14px;
    line-height: 16px;
    height: 32px;
    padding: 4px 8px;
  `,
};

export const Chip = styled.span<{
  $color: string;
  $variant: 'filled' | 'outlined';
  $size: 'small' | 'medium';
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ $size }) => ($size === 'small' ? '4px' : '8px')};
  font-weight: 500;
  white-space: nowrap;
  line-height: 1;
  ${({ $size }) => sizeStyles[$size]}

  ${({ $variant, $color }) =>
    $variant === 'outlined'
      ? css`
          border: 1px solid ${$color};
          color: ${$color};
          background-color: transparent;
        `
      : css`
          border: none;
          color: #fff;
          background-color: ${$color};
        `}
`;

export const FallbackChip = styled.span<{ $size: 'small' | 'medium' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ $size }) => ($size === 'small' ? '4px' : '8px')};
  white-space: nowrap;
  line-height: 1;
  background-color: ${({ theme }) => theme.colors['neutral-20']};
  color: ${({ theme }) => theme.colors['neutral-80']};
  ${({ $size }) => sizeStyles[$size]}
`;
